import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import _classCallCheck from "reshow-runtime/es/helpers/classCallCheck";
import _createClass from "reshow-runtime/es/helpers/createClass";
import _assertThisInitialized from "reshow-runtime/es/helpers/assertThisInitialized";
import _possibleConstructorReturn from "reshow-runtime/es/helpers/possibleConstructorReturn";
import _getPrototypeOf from "reshow-runtime/es/helpers/getPrototypeOf";
import _inherits from "reshow-runtime/es/helpers/inherits";
import _defineProperty from "reshow-runtime/es/helpers/defineProperty";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { mixClass, SemanticUI } from 'react-atomic-molecule';
import { Change } from 'organism-react-animate';
import CarouselNavigation from '../organisms/CarouselNavigation';

var CarouselAnimation = /*#__PURE__*/function (_Component) {
  _inherits(CarouselAnimation, _Component);

  var _super = _createSuper(CarouselAnimation);

  function CarouselAnimation() {
    var _this;

    _classCallCheck(this, CarouselAnimation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleSelected", function (_ref) {
      var activeEl = _ref.activeEl,
          selected = _ref.selected,
          handleChange = _ref.handleChange;
      var animate = _this.props.animate;
      return /*#__PURE__*/React.createElement(Change, animate, activeEl);
    });

    return _this;
  }

  _createClass(CarouselAnimation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animate = _this$props.animate,
          className = _this$props.className,
          others = _objectWithoutProperties(_this$props, ["animate", "className"]);

      var classes = mixClass('carousel-animation', className);
      return /*#__PURE__*/React.createElement(CarouselNavigation, _extends({}, others, {
        className: classes,
        onSelected: this.handleSelected
      }));
    }
  }]);

  return CarouselAnimation;
}(Component);

_defineProperty(CarouselAnimation, "defaultProps", {
  animate: {
    enter: 'fadeIn-500',
    leave: 'fadeOut-100'
  }
});

export default CarouselAnimation;